import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["unread"]
  static values = {
    latestDate: Number
  }

  unreadTargetConnected(el) {
    const lastViewedTimestamp = parseInt(localStorage.getItem('lastViewedChangelogDate'), 10) || 0
    const latestTimestamp = this.latestDateValue

    if (latestTimestamp > lastViewedTimestamp) {
      el.classList.remove('hidden')
    } else {
      el.classList.add('hidden')
    }
  }

  markAsViewed() {
    localStorage.setItem('lastViewedChangelogDate', this.latestDateValue.toString())
    this.unreadTargets.forEach(target => target.classList.remove('hidden'))
  }
}
